import { render, staticRenderFns } from "./foodHowItWorks.vue?vue&type=template&id=16956884&scoped=true&"
import script from "./foodHowItWorks.vue?vue&type=script&lang=js&"
export * from "./foodHowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./foodHowItWorks.vue?vue&type=style&index=0&id=16956884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16956884",
  null
  
)

export default component.exports